import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassportShortenPipe } from 'src/app/pipes/passportShorten.pipe';

@NgModule({
  declarations: [
    PassportShortenPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PassportShortenPipe
  ]
})
export class SharedModule { }
